import { AppDispatch } from '@store/index'
import { sendConnectCommand } from '@store/actions'

export const connectSoundAPI = async (
  type: React.MutableRefObject<string>,
  session_id: React.MutableRefObject<string>,
  dispatch: AppDispatch,
): Promise<string> => {
  /*
  This function is used to initialized connection to ther server 
  Args:
    type       (MutableRefObject<string>):  Type of string as (free/keywords)
    session_id (MutableRefObject<string>):  Unique identifier for user per session
  Returns:
    str : Return a string to confirm connection or warn of connection failure 
  */

  // Initialize connection
  const action = await dispatch(
    sendConnectCommand({
      isFirst: true,
      stream: true,
      session_id: session_id,
      type: type,
    }),
  )

  // Check if the action has a payload and if 'result' exists
  if (
    'payload' in action &&
    typeof action.payload === 'object' &&
    action.payload &&
    'result' in action.payload
  ) {
    return action.payload.result ? 'connected' : 'failed'
  } else {
    return 'failed'
  }
}
